import { SHOW_MODAL, HIDE_MODAL } from './actions';

const initialState = {
  component: null,
  props: {},
};

function modalReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        component: action.payload.component,
        props: action.payload.props,
      };
    case HIDE_MODAL:
      return initialState;
    default:
      return state;
  }
}

export default modalReducer;
